export const listIdObj: any = {
    us: {
        a_productId: '7185477075017',
        a_variantId: '41385721004105',
        a_subs: [
            {
                name: 'EcoFlow Smart Home Panel 2',
                parentVariantId: '41385721004105',
                productId: '7213436534857',
                variantId: '41435086618697',
            },
            {
                name: 'EcoFlow DELTA Pro 3 Smart Extra Battery*2',
                parentVariantId: '41385808265289',
                productId: '7213639696411',
                variantId: '41436110520311',
                timeStart: '2024/06/11 10:00:00 GMT+8',
                timeEnd: '2024/06/12 10:00:00 GMT+8',
            },
        ],

        b_productId: '7185557127241',
        b_variantId: '41385808265289',
        b_subs: [
            {
                name: 'EcoFlow DELTA Pro 3 Smart Extra Battery*2',
                parentVariantId: '41385808265289',
                productId: '7213639696457',
                variantId: '41436110520393',
            },
        ],

        c_productId: '7199648972873',
        c_variantId: '41410973958217',
        c_subs: [
            {
                name: 'EcoFlow DELTA Pro 3 Smart Extra Battery',
                parentVariantId: '41410973958217',
                productId: '7213639696457',
                variantId: '41436110389321',
            },
        ],
    },
    ca: {
        a_productId: '8231332380826',
        a_variantId: '44902384599194',

        b_productId: '8231518666906',
        b_variantId: '44902577242266',

        c_productId: '8233477046426',
        c_variantId: '44906482303130',
    },
};

export const listIdObj2: any = {
    us: {
        a_productId: '6905537888329',
        a_variantId: '40538145095753',
        a_subs: [
            {
                isActive: true,
                img: 'https://www.ecoflow.com/responsive/picture/common-products/deltapro.png',
                sortName: '400W',
                name: 'EcoFlow 400W Portable Solar Panel (DELTA Pro)',
                parentVariantId: '6905537888329',
                productId: '6618094960713',
                variantId: '39998021697609',
                quantity: 1,
                recommandNum: 3,
                energy: 399,
            },
            {
                img: 'https://www.ecoflow.com/responsive/picture/common-products/deltapro.png',
                sortName: '220W',
                name: 'EcoFlow 220W Bifacial Portable Solar Panel (DELTA Pro)',
                parentVariantId: '6905537888329',
                productId: '6687135957065',
                variantId: '40573832495177',
                quantity: 2,
                recommandNum: 4,
                energy: 210,
            },
            {
                img: 'https://www.ecoflow.com/responsive/picture/common-products/deltapro.png',
                sortName: '160W',
                name: 'EcoFlow 160W Portable Solar Panel (DELTA Pro)',
                parentVariantId: '6905537888329',
                productId: '4605523198025',
                variantId: '40573832429641',
                quantity: 3,
                recommandNum: 6,
                energy: 155,
            },
        ],

        b_productId: '7185557127241',
        b_variantId: '41385808265289',
        b_subs: [
            {
                isActive: true,
                img: 'https://www.ecoflow.com/responsive/picture/common-products/deltapro.png',
                sortName: '400W',
                name: 'EcoFlow 400W Portable Solar Panel (DELTA Pro)',
                parentVariantId: '7185557127241',
                productId: '6618094960713',
                variantId: '39998021697609',
                quantity: 1,
                recommandNum: 3,
                energy: 399,
            },
            {
                img: 'https://www.ecoflow.com/responsive/picture/common-products/deltapro.png',
                sortName: '220W',
                name: 'EcoFlow 220W Bifacial Portable Solar Panel (DELTA Pro)',
                parentVariantId: '7185557127241',
                productId: '6687135957065',
                variantId: '40573832495177',
                quantity: 2,
                recommandNum: 4,
                energy: 210,
            },
            {
                img: 'https://www.ecoflow.com/responsive/picture/common-products/deltapro.png',
                sortName: '160W',
                name: 'EcoFlow 160W Portable Solar Panel (DELTA Pro)',
                parentVariantId: '7185557127241',
                productId: '4605523198025',
                variantId: '40573832429641',
                quantity: 3,
                recommandNum: 6,
                energy: 155,
            },
        ],

        c_productId: '7199648972873',
        c_variantId: '41410973958217',
        c_subs: [
            {
                isActive: true,
                img: 'https://www.ecoflow.com/responsive/picture/common-products/deltapro.png',
                sortName: '400W',
                name: 'EcoFlow 400W Portable Solar Panel (DELTA Pro)',
                parentVariantId: '7199648972873',
                productId: '6618094960713',
                variantId: '39998021697609',
                quantity: 1,
                recommandNum: 3,
                energy: 399,
            },
            {
                img: 'https://www.ecoflow.com/responsive/picture/common-products/deltapro.png',
                sortName: '220W',
                name: 'EcoFlow 220W Bifacial Portable Solar Panel (DELTA Pro)',
                parentVariantId: '7199648972873',
                productId: '6687135957065',
                variantId: '40573832495177',
                quantity: 2,
                recommandNum: 4,
                energy: 210,
            },
            {
                img: 'https://www.ecoflow.com/responsive/picture/common-products/deltapro.png',
                sortName: '160W',
                name: 'EcoFlow 160W Portable Solar Panel (DELTA Pro)',
                parentVariantId: '7199648972873',
                productId: '4605523198025',
                variantId: '40573832429641',
                quantity: 3,
                recommandNum: 6,
                energy: 155,
            },
        ],
    },
    ca: {
        a_productId: '8231332380826',
        a_variantId: '44902384599194',

        b_productId: '8231518666906',
        b_variantId: '44902577242266',

        c_productId: '8233477046426',
        c_variantId: '44906482303130',
    },
};
